import Vue from 'vue'

const state = {
  rowsByServer: {},
  updatedAtByServer: {}
}

const getters = {
  scriptErrorsByServer: state => state.rowsByServer,
  scriptErrorsUpdatedAtByServer: state => state.updatedAtByServer
}

const actions = {
  getScriptErrors ({ commit }, payload) {
    commit('setScriptErrors', payload.data)
  }
}

const mutations = {
  setScriptErrors (state, payload) {
    const server = payload && payload.server ? payload.server : 'gold'
    Vue.set(state.rowsByServer, server, payload && payload.rows ? payload.rows : [])
    Vue.set(state.updatedAtByServer, server, payload && payload.refreshed_at ? payload.refreshed_at : new Date().toISOString())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
